// extracted by mini-css-extract-plugin
export default {"validationFailures":"Form-validationFailures-wVc3a"};